import { useParams } from 'react-router-dom';

import useUser from '../../authentication/context/useUser';
import useConfiguration from '../../useConfiguration';
import { useProject } from '../context/useProject';
import { APropos } from './pages/APropos';
import { Co2 } from './pages/Co2';
import { Co2Details } from './pages/Co2Details';
import { Cover } from './pages/Cover';
import { LastPage } from './pages/LastPage';
import { SocialUtility } from './pages/SocialUtility';

const Pdf = () => {
  const { projectId } = useParams();
  const { user } = useUser();
  const { project } = useProject(projectId);
  const { configuration } = useConfiguration();
  if (!project || !user) {
    return null;
  }
  return (
    <>
      <Cover project={project} user={user} />
      <Co2 project={project} user={user} configuration={configuration} />
      <Co2Details project={project} user={user} configuration={configuration} />
      <SocialUtility
        project={project}
        user={user}
        configuration={configuration}
      />
      <APropos project={project} user={user} />
      <LastPage />
    </>
  );
};

export default Pdf;
